import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import FlowPlayerControls from "../../controls/FlowPlayerControls";

function MessagesStepView({ controller, messages }) {
  return (
    <FlowPlayerControls controller={controller}>
      <StyledFlexColumn>
        {messages.map((message, index) => (
          <div key={index} dangerouslySetInnerHTML={{ __html: message }} />
        ))}
      </StyledFlexColumn>
    </FlowPlayerControls>
  );
}

export default MessagesStepView;
